// Grilluxe Outdoor Living — Theme Grundgerüst (Phase 1).
// Noch keine Komponenten-Logik (Header/Cart/Search/Predictive Search folgen in
// späteren Phasen). Bewusst leer gehalten, keine unnötigen Dependencies.
document.documentElement.classList.remove("no-js");
